import classNames from "classnames";
import { DotsCheckbox } from "dots-ui/dotsCheckbox";
import { FormikProps } from "formik";
import { useContext, useState } from "react";
import { PublicMusicalCreationListFilter } from "../../../../generated/data-contracts";
import { FormikUtils } from "../../../../utils";
import { FilterActions } from "../../../shared/components/form";
import { AvisInputTextWithFilterType } from "../../../shared/components/inputs";
import { AvisContext } from "../../../shared/context/AvisContext";

interface IPublicCreationsFilterFormProps {
  bag: FormikProps<PublicMusicalCreationListFilter>;
  loading: boolean;
  filtered: boolean;
}

export function PublicCreationsFilterForm(
  props: Readonly<IPublicCreationsFilterFormProps>,
) {
  const { bag, loading } = props;
  const { res, getText } = useContext(AvisContext);
  const [acceptMusicSearchTerms, setAcceptMusicSearchTerms] =
    useState<boolean>(false);
  const classNameSecondColumn = classNames("blank-media-filter-name", "col-6");

  const emptyFilter =
    !bag.values.creationName?.trim() &&
    !bag.values.rightsHolderNameOrIpiNumber?.trim();
  const disabledControls = loading || !acceptMusicSearchTerms;

  const handleKeyPress = (e: React.KeyboardEvent<HTMLInputElement>) => {
    const enabledFilterButton = !(disabledControls || emptyFilter);
    if (enabledFilterButton) FormikUtils.handleEnterKeyPress(e, bag.submitForm);
  };
  return (
    <>
      <div className="public-creations-accept-terms flex">
        <DotsCheckbox
          checked={acceptMusicSearchTerms}
          onChange={(_e, value) => setAcceptMusicSearchTerms(value)}
        />
        <div className="pl-2">
          {getText("portal_PUBL_MusicCreations_Confirm")}
        </div>
      </div>
      <div className="row">
        <AvisInputTextWithFilterType<PublicMusicalCreationListFilter>
          className={classNameSecondColumn}
          label={res("label_CreationName")}
          bag={bag}
          bagField="creationName"
          bagFieldFilterType="creationNameFilterType"
          disabled={disabledControls}
          minLength={2}
          maxLength={200}
          onKeyDown={handleKeyPress}
        />
      </div>
      <div className="row">
        <AvisInputTextWithFilterType<PublicMusicalCreationListFilter>
          className={classNameSecondColumn}
          label={res("public_MusicalCreations_AuthorNameOrIPI")}
          bag={bag}
          bagField="rightsHolderNameOrIpiNumber"
          bagFieldFilterType="rightsHolderNameOrIpiNumberFilterType"
          disabled={disabledControls}
          minLength={2}
          maxLength={200}
          onKeyDown={handleKeyPress}
        />
      </div>
      <div className="row">
        <div className="col-12">
          <DotsCheckbox<PublicMusicalCreationListFilter>
            checkboxLabel={res("label_SearchAllCreationNames")}
            bag={bag}
            bagField="searchAllNames"
            disabled={disabledControls}
          />
        </div>
      </div>
      <FilterActions
        bag={bag}
        loading={disabledControls || emptyFilter}
        res={res}
      />
    </>
  );
}
